import { createStyles } from '@material-ui/core';

export const styles = () =>
    createStyles({
        header: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        button: {
            width: '25px',
            height: 'auto',
            marginBottom: '5px'
        },
        sync: {
            width: '20px'
        }
    });
